<template>
  <div class="dashboard-container">
    <div class="app-container">标签添加</div>
  </div>
</template>

<script>
export default {
  name: 'TagsAdd',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
